export default __webpack_public_path__ + "static/12_16-1--167651b51a4f3e9c8ab9f28af034bf3c.png";